import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { createPinia } from 'pinia'

const pinia = createPinia()

// 路由配置
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginPage.vue')
  },
  {
    path: '/article-management',
    name: 'ArticleManagement',
    component: () => import('../views/ArticleManagement.vue')
  },
  {
    path: '/course-management',
    name: 'CourseManagement',
    component: () => import('../views/CourseManagement.vue')
  },
  {
    path: '/course-detail/:id',
    name: 'CourseDetail',
    component: () => import('../views/CourseDetail.vue')
  },
  {
    path: '/create-course',
    name: 'CreateCourse',
    component: () => import('../views/CourseTypeSelection.vue')
  },
  {
    path: '/create-column',
    name: 'CreateColumn',
    component: () => import('../views/CourseTypeSelection.vue')
  },
  {
    path: '/publish-course',
    name: 'PublishCourse',
    component: () => import('../views/PublishCourse.vue')
  },
  {
    path: '/about-us',
    name: 'AboutUs',
    component: () => import('../views/AboutUs.vue')
  },
  {
    path: '/create-article/:id?',
    name: 'CreateArticle',
    component: () => import('../views/CreateArticle.vue')
  },
  {
    path: '/audio-course-generator',
    name: 'AudioCourseGenerator',
    component: () => import('../views/AudioCourseGenerator.vue')
  },
  {
    path: '/audio-course-generate',
    name: 'AudioCourseGenerate',
    component: () => import('../views/AudioCourseGenerate.vue')
  },
  {
    path: '/audio-course-history',
    name: 'AudioCourseHistory',
    component: () => import('../views/AudioCourseHistory.vue')
  },
  {
    path: '/create-audio-course',
    name: 'CreateAudioCourse',
    component: () => import('../views/CreateAudioCourse.vue')
  },
  {
    path: '/my-ai-course',
    name: 'MyAICourse',
    component: () => import('../views/MyAICourse.vue')
  },
  {
    path: '/operation-management',
    name: 'OperationManagement',
    component: () => import('../views/OperationManagement.vue')
  }
]

// 创建路由实例
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 登录页面不需要验证
  if (to.path === '/login') {
    next()
    return
  }
  
  // 检查是否有token
  const userStore = useUserStore(pinia)
  const token = userStore.token
  
  // 如果没有token，重定向到登录页
  if (!token) {
    next('/login')
    return
  }
  
  // 有token，继续访问
  next()
})

export default router